var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("base-item-group", {
    attrs: {
      item: _vm.item,
      value: true,
      "no-action": "",
      text: "",
      "sub-group": ""
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }